import React, { useEffect, useMemo, useState } from "react";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";

import Draggable from "react-draggable";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#dialog-objetivo-v2-cliente-patamar-faturas-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function toISODate(value) {
  if (!value) return "";

  return String(value).slice(0, 10);
}

function fmtNumero(value, casas = 0) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const n = Number(value);

  if (!Number.isFinite(n)) {
    return "";
  }

  return n.toLocaleString("pt-PT", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

export default function DialogObjetivoV2ClientePatamarFaturas({
  open,
  onClose,
  idObjetivo,
  patamar,
  cliente,
}) {
  const { showAlert } = useAlert();

  const [loading, setLoading] = useState(false);
  const [detalhe, setDetalhe] = useState(null);

  useEffect(() => {
    let ativo = true;

    const carregar = async () => {
      const idobjetivo = Number(idObjetivo || 0);
      const idpatamar = Number(patamar?.idpatamar || patamar?.id || 0);
      const refcliente = String(cliente?.refcliente || "").trim();

      if (!open || idobjetivo <= 0 || idpatamar <= 0 || !refcliente) {
        setDetalhe(null);
        return;
      }

      setLoading(true);
      setDetalhe(null);

      try {
        const [payload, err] = await handleApi(
          api.post("Comercial/SelObjetivoV2ClientePatamarFaturas", {
            idobjetivo,
            idpatamar,
            refcliente,
          })
        );

        if (!ativo) {
          return;
        }

        if (err) {
          showAlert(err, "error");
          return;
        }

        setDetalhe(payload?.data ?? payload ?? null);
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    };

    carregar();

    return () => {
      ativo = false;
    };
  }, [open, idObjetivo, patamar?.idpatamar, patamar?.id, cliente?.refcliente, showAlert]);

  const columns = useMemo(
    () => [
      {
        Header: "Data",
        accessor: "faturadata",
        width: 110,
        Cell: ({ value }) => toISODate(value),
      },
      {
        Header: "Fatura",
        accessor: "faturanumero",
        width: 140,
      },
      {
        Header: "Ref. material",
        accessor: "refmaterial",
        width: 140,
      },
      {
        Header: "Material",
        accessor: "material",
        width: 360,
      },
      {
        Header: "Qtd.",
        accessor: "qtd",
        width: 90,
        align: "right",
        headerAlign: "right",
        Cell: ({ value }) => fmtNumero(value, 0),
      },
    ],
    []
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperComponent={PaperComponent}
      PaperProps={{
        sx: {
          width: {
            xs: "calc(100vw - 24px)",
            sm: "90vw",
            md: 980,
          },
          maxWidth: "calc(100vw - 24px)",
        },
      }}
    >
      <DialogTitle id="dialog-objetivo-v2-cliente-patamar-faturas-title" sx={{ cursor: "move" }}>
        Faturas do cliente
      </DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <MDBox py={4} display="flex" justifyContent="center">
            <CircularProgress size={28} />
          </MDBox>
        ) : detalhe ? (
          <>
            <MDBox mb={2}>
              <MDTypography variant="button" color="text" display="block">
                {detalhe?.cliente?.nome || ""}
                {" · "}
                {detalhe?.cliente?.refcliente || ""}
              </MDTypography>

              <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                Patamar: {detalhe?.patamar?.nome || ""}
              </MDTypography>

              <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                Período: {toISODate(detalhe?.objetivo?.dataini)}
                {" a "}
                {toISODate(detalhe?.objetivo?.datafim)}
              </MDTypography>
            </MDBox>

            <MDBox
              sx={{
                maxWidth: "100%",
                overflow: "auto",
              }}
            >
              <ProjectTable
                tableKey={`objetivos-v2-cliente-patamar-faturas-${detalhe?.patamar?.id || "x"}-${
                  detalhe?.cliente?.refcliente || "x"
                }`}
                version="v1"
                columns={columns}
                data={detalhe?.faturas || []}
                emptyMessage="Sem faturas para apresentar."
                minWidth={900}
                maxHeight="60vh"
                showKeepFilters
              />
            </MDBox>
          </>
        ) : null}
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
